import { Injectable } from '@angular/core';
import { API } from './api.service';
import { ES } from './es.service';
import { AuthService } from './auth-service';
import { BasicSearchParams } from './search.service';
import * as _ from 'lodash';
import { Http, Headers } from '@angular/http';
import { Globals } from '../../app.globals';
import { CreatePlaylistForm } from '../../../models';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PlaylistService {
  // to update the playlist without refreshing the page
  public isPlaylistUpdated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // to update the discovery list without refreshing the page
  public isMyDiscoveryUpdated = new BehaviorSubject(0);
  public myMusicCollectionID = new BehaviorSubject(0);
  // to detect the avatar change on playlist detail page
  public playlistAvatarUpdated: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);

  constructor(private api: API, private es: ES, private userService: AuthService, private http: Http) {
  }

  getPlaylists(type: string, page: any = false, sortOrder: any = false, limit = 20, user = false, term = '') {
    // let queryParams = 'time=' + Date.now();
    let queryParams = 'time=123';
    let playlistType = (typeof type === 'undefined' || type === 'F' || type === 'WF') ? 'P' : type;
    let params: any = {
      'type': playlistType,
    };
    let visibility;
    if ((type === 'P' || type === 'F')) {
      visibility = 'Public';
    } else {
      visibility = 'system';
    }
    if (playlistType) {
      queryParams += '&type=' + playlistType;
    }
    if (playlistType) {
      queryParams += '&visibility=' + visibility;
    }
    if (limit) {
      queryParams += '&limit=' + limit;
    }
    if (page) {
      queryParams += '&page=' + page;
    }
    if (user) {
      queryParams += '&user_id=' + this.userService.getLoggedInUserId();
    }
    queryParams += '&direct=' + 1;
    if (sortOrder && sortOrder.key) {
      queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
    }
    if (term != "") {
      queryParams += "&q=" + term;
    }
    return this.api.get('playlists?' + queryParams);
  }

  public getCall() {
    return this.api.get('songs/call');
  }

  getPlaylistDetailsByIds(ids, sortOrder: any = false) {
    // let queryParams = 'time=' + Date.now();
    let queryParams = 'time=123';
    ids.forEach(function (arrayItem) {
      queryParams += '&id[]=' + arrayItem;
    });
    if (sortOrder && sortOrder.key) {
      queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
    }
    return this.api.get('playlists?' + queryParams);
  }

  getMyPlaylistIds(page: any = false, searchQuery = null) {
    let options = this.es.setCriteria({
      'type': 'P',
      'user_id': this.userService.getLoggedInUserId()
    }, 'playlist', page, searchQuery);
    if (typeof options.body.query.filtered.filter.bool.should === 'undefined') {
      options.body.query.filtered.filter.bool.should = [];
    }
    options.body.query.filtered.filter.bool.should.push({ 'match': { 'visibility': 'Public' } });
    options.body.query.filtered.filter.bool.should.push({ 'match': { 'visibility': 'Private' } });
    return this.es.listing(options).then((body) => {
      let hits = body.hits.hits;
      return _.keys(_.groupBy(hits, '_id'));
    });
  }

  public loadPlaylist(type: string, page: any = false, searchQuery: any = null) {
    let playlistType = (typeof type === 'undefined' || type === 'F' || type === 'WF') ? 'P' : type;
    let params: any = {
      'type': playlistType,
    };
    if ((type === 'P' || type === 'F')) {
      params.visibility = 'Public';
    } else {
      params.visibility = 'system';
    }

    let options = this.es.setCriteria(params, 'playlist', page, searchQuery);
    return this.es.listing(options).then((body) => {
      let hits = body.hits.hits;
      return _.map(_.filter(hits, function (item: any) { return item._id; }), '_id');
    });
  }

  public addPlaylistToDiscoveries(playlist) {
    return this.api.post('api/add-to-discovery', playlist);
  }

  public removePlaylistFromDiscoveries(playlist) {
    return this.api.post('api/remove-from-discovery', playlist);
  }

  public deletePlaylist(id: string) {
    return this.api.post('playlists/delete', { id: id });
  }

  public getPlaylistPic(id: string) {
    let headers = new Headers();
    if (!!localStorage.getItem('auth_token')) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('auth_token'));
    }
    return this.http.get(new Globals().apiEndpoint + 'playlists/get-avatar?playlist_id=' + id, headers);
  }

  public getPlaylistSongs(id: number) {
    return this.api.get('playlists/playlist-songs/?playlistId=' + id);
  }

  public getPlaylistDetail(id: any) {
    return this.api.get('playlists/by-slug/' + id);
  }

  public updatePlaylist(playlist: CreatePlaylistForm) {
    return this.api.post('playlists/update?id=' + playlist.id, playlist);
  }

  public updatePlaylistAvatar(id: string, image: string) {
    return this.api.post('playlists/upload-playlist-avatar', { id: id, image: image });
  }

  public createQuePlaylistWithSongs(playlist: CreatePlaylistForm, song: any) {
    playlist.song_id = song.id;
    return this.api.post('playlists/new-playlist-with-songs', { playlist: playlist, songs: song });
  }

  public createPlaylistWithSongs(playlist: CreatePlaylistForm, song: any) {
    playlist.song_id = song.id;
    let tmpSong = new Array<any>();
    tmpSong.push(song);
    return this.api.post('playlists/new-playlist-with-songs', { playlist: playlist, songs: tmpSong });
  }

  public togglePlaylistToFavorites(id: string, type: string, domainInfo) {
    return this.api.post('playlists/like', { object: id, type: type, domainInfo: domainInfo });
  }

  public fetchSongs(playlist: any) {
    return this.getPlaylistSongs(playlist.id).map((res) => {
      return res;
    });
  }

  public setNewSongsOrder(playlistId: string, newOrder: Array<any>) {
    return this.api.post('playlists/songs-sort?id=' + playlistId, newOrder);
  }

  public setNewOrder(newOrder: Array<any>) {
    return this.api.post('playlists/sort', newOrder);
  }

  public simplify(item: any) {
    let tmp = item.description.split("|");
    item.description = (tmp[0]) ? tmp[0] : "";
    item.created_by = (tmp[1]) ? tmp[1] : "";
    return item;
  }

  public loadSearchedPlaylist(queryString: string) {
    let criteria = new BasicSearchParams();
    criteria.searchSongs = false;
    criteria.searchArtists = false;
    criteria.searchPlaylists = true;
    let options = this.es.getBasicSearchCriteria(queryString, criteria);
    return this.es.listing(options).then((body) => {
      let hits = body.hits.hits;
      return _.keys(_.groupBy(hits, '_id'));
    });
  }

  getUserPlaylists(page: any = false, limit = 20, sortOrder: any = false) {
    let queryParams;
    if (limit) {
      queryParams += '&limit=' + limit;
    }
    if (page) {
      queryParams += '&page=' + page;
    }
    if (sortOrder && sortOrder.key) {
      queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
    }
    return this.api.get('playlists/user-playlists?' + queryParams);
  }

  // to get the songs of playlist using limit
  public getPlaylistSongsList(ids: any, page: any = false) {
    return this.api.post('playlists/playlist-songs-list/', { page: page, songIds: ids });
  }

}



// WEBPACK FOOTER //
// ./src/app/api/services/playlist-service.ts